import React, { useRef, useLayoutEffect } from 'react';

interface AutoResizeTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

const AutoResizeTextarea: React.FC<AutoResizeTextareaProps> = ({
  label,
  error,
  className = '',
  value,
  onChange,
  ...props
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const errorClass = error ? 'ring-2 ring-red-500' : '';

  useLayoutEffect(() => {
    if (textareaRef.current) {
      // Reset height to allow shrinking
      textareaRef.current.style.height = 'auto';
      // Set height based on scrollHeight, plus a little buffer to prevent scrollbar flicker
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <div className="w-full">
      {label && (
        <label className="block text-[10px] uppercase tracking-widest text-zinc-500 mb-1 font-mono">
          {label}
        </label>
      )}
      <textarea
        ref={textareaRef}
        className={`textarea ${errorClass} ${className} overflow-hidden`}
        value={value}
        onChange={onChange}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-danger">{error}</p>}
    </div>
  );
};

export default AutoResizeTextarea;
